import { render } from "./GroupsManagement.vue?vue&type=template&id=3bdfacb9&scoped=true"
import script from "./GroupsManagement.vue?vue&type=script&lang=js"
export * from "./GroupsManagement.vue?vue&type=script&lang=js"

import "./GroupsManagement.vue?vue&type=style&index=0&id=3bdfacb9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bdfacb9"]])

export default __exports__